<template>
	<div>
		<j-base-multi-select-with-flexible-value
			:id="id"
			:options="options"
			:valuesVisibleOnLoad="this.valuesVisibleOnLoad"
			:value="value"
			:placeholder="placeholder ? placeholder : $t('select_organization')"
			:allowLocalSearch="false"
			:allowMultiselect="allowMultiselect"
			:status="status"
			:size="size"
			valueKey="id"
			nameKey="name"
			@input="onInput($event)"
			@search="onSearch($event)"
		/>
	</div>
</template>

<script>
/**
 * This component is responsible for listing internals
 * @returns array of objects with selected internals
 */
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "../api/"

export default {
	components: { JBaseMultiSelectWithFlexibleValue },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true,
			default: () => []
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		size: {
			type: String,
			required: false,
			default: "medium"
		},
		allowMultiselect: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: null
		},
		valuesVisibleOnLoad: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			options: []
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
		},

		async onSearch(searchTerm = null) {
			const where = { name_contains: searchTerm }
			const sort = { fieldName: "name", type: "asc" }

			let res = await api.organizations({ sort, where })
			if (!res.errors) this.options = res.data.organizations.list
		}
	},

	created() {
		if (this.valuesVisibleOnLoad === true) {
			this.onSearch("") // insert '' in multiselect search bar to trigger/return all values without typing anything
		}
	}
}
</script>
